import { render, staticRenderFns } from "./dingtalk.vue?vue&type=template&id=377bfa57&scoped=true&"
import script from "./dingtalk.vue?vue&type=script&lang=js&"
export * from "./dingtalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377bfa57",
  null
  
)

export default component.exports